import { ReactElement, ReactNode } from 'react';
import { Controller, Control, ControllerProps, useFormContext } from 'react-hook-form';
import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  CheckboxProps,
  FormControlLabelProps,
  FormHelperText,
  FormControl,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

type Props = CheckboxProps &
  Omit<ControllerProps, 'control' | 'render'> & {
    label?: ReactNode;
    formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'>;
    control?: Control<any>; // eslint-disable-line
  };

const useStyles = makeStyles(() =>
  createStyles({
    errorText: {
      marginTop: 0,
    },
  }),
);

export const ControlledCheckbox = ({
  control: controlProp,
  label,
  formControlLabelProps,
  ...props
}: Props): ReactElement => {
  const formContext = useFormContext();
  const control = controlProp || formContext?.control;
  const classes = useStyles();
  return (
    <Controller
      control={control}
      render={({ field: { value, onChange, ...fieldRest }, fieldState }) => (
        <FormControl error={Boolean(fieldState.error)}>
          <FormControlLabel
            control={
              <MuiCheckbox
                {...props}
                {...fieldRest}
                color="primary"
                checked={value || false}
                onChange={(e) => onChange(e.target.checked)}
              />
            }
            label={label}
            {...formControlLabelProps}
          />
          {fieldState.error && (
            <FormHelperText className={classes.errorText}>{fieldState.error?.message}</FormHelperText>
          )}
        </FormControl>
      )}
      {...props}
    />
  );
};

export default ControlledCheckbox;
